<template>
  <div class="check-work-body">
    <div style="display: flex;flex-direction: row">
      <div style="width: 200px">
        <area-tree @nodeClick="nodeClick1"></area-tree>
      </div>
      <div>
        <div class="search-wrap">
          <el-form :inline="true">
            <el-form-item>
              <el-input size="mini" placeholder="客户名称/项目名称/发票号" v-model="keyword" clearable style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                size="mini"
                v-model="start_month"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM"
                placeholder="选择月">
              </el-date-picker> -
              <el-date-picker
                size="mini"
                v-model="end_month"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM"
                placeholder="选择月">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-select size="mini" v-model="entry_type_name" placeholder="业务类型" clearable>
                <el-option
                  v-for="item in business_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select size="mini" v-model="check_status" placeholder="审核状态">
                <el-option
                  v-for="item in [{'name':'全部','value':''},{'name':'未审','value':'0'},{'name':'已审','value':'1'}]"
                  :key="item.name"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" @click="Api.downloadInvoiceTemplate(search_params)">导出模板</el-button>
            </el-form-item>
            <el-form-item>
              <el-upload :action="upload_url" :on-success="uploadComplete" :file-list="upload_file_list">
                <el-button size="mini">导入开票</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" @click="Api.downloadInvoiceData(search_params)">导出数据</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div class="table-wrap">
          <el-table v-if="pageData" v-loading="loading" :data="pageData.list" @selection-change="handleSelectionChange">
            <el-table-column prop="party_a" label="客户名称" align="center" width="200"></el-table-column>
            <el-table-column prop="project_name" label="项目名称" align="center" width="200"></el-table-column>
            <el-table-column prop="entry_type_name" label="业务类型" align="center" width="80"></el-table-column>
            <el-table-column prop="month" label="应收月份" width="100" align="center"></el-table-column>
            <el-table-column prop="amount" label="合同金额" align="center"></el-table-column>
            <el-table-column prop="invoice_amount" label="应收金额" align="center"></el-table-column>
            <el-table-column prop="invoiced_amount" label="已开票金额" align="center"></el-table-column>
            <el-table-column prop="not_invoice_amount" label="待开票金额" align="center"></el-table-column>
            <el-table-column prop="status" label="变动是否审核" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" :type="scope.row.check_status > 0 ?'success':'danger'">{{scope.row.check_status > 0 ?'已审':'未审'}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作 " align="center" width="320">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" icon="el-icon-edit" v-if="ERP.isPermission(26005002002002)" @click="invoice(scope.row)">开发票</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>



    <!-- 修改窗口 -->
    <el-dialog title="开发票" :visible.sync="dialogVisible" :close-on-click-modal="false">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-form :model="form" ref="form" :rules="rules" label-width="100px" size="mini" style="margin-right: 50px;">

<!--          <el-form-item label="发票名称" prop="title">-->
<!--            <el-input class="form-input" v-model="form.name" autocomplete="off"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label="发票类型" prop="invoice_type">
            <el-select v-model="form.invoice_type" placeholder="发票类型" clearable>
              <el-option
                v-for="item in [
                  {'name':'专用发票'},
                  {'name':'普通发票'},
                  {'name':'电子普票'},
                  {'name':'电子专票'}
                  ]"
                :key="item.name"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票票号" prop="ticket_no">
            <el-input class="form-input" v-model="form.ticket_no" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="各项金额" prop="title">
            <el-table :data="multipleSelection">
              <el-table-column prop="party_a" label="客户名称" align="center" width="120"></el-table-column>
              <el-table-column prop="project_name" label="项目名称" align="center" width="120"></el-table-column>
              <el-table-column prop="entry_type_name" label="业务类型" align="center"></el-table-column>
<!--              <el-table-column prop="name" label="费项名称" align="center" width="120"></el-table-column>-->
              <el-table-column prop="month" label="应收月份" align="center"></el-table-column>
              <el-table-column prop="amount" label="合同金额" align="center"></el-table-column>
              <el-table-column prop="not_invoice_amount" label="未开票金额" align="center"></el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="开票金额" prop="title">
            <el-input class="form-input" v-model="form.amount" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="发票时间" prop="invoice_time">
            <el-date-picker
              v-model="form.invoice_time"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="附件" prop="title">
            <upload-files-sysc :host-url="host_url" :upload-url="host_url+'/contract/project/uploadFile'"  :limit="20" v-model="form.files"></upload-files-sysc>
          </el-form-item>

          <el-form-item label="备注" prop="title">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="form.remarks"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>

        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" >确 定</el-button>
      </div>
    </el-dialog>

    <!-- 开票列表弹框 -->
    <el-dialog title="开票列表" :visible.sync="invoiceListVisible" width="80%">
        <el-button type="primary" @click="invoiceForm">开票登记</el-button>
        <el-table :data="invoiceList">
          <el-table-column prop="invoice_type" label="类型"></el-table-column>
          <el-table-column prop="ticket_no" label="发票号"></el-table-column>
          <el-table-column prop="amount" label="开票金额"></el-table-column>
          <el-table-column prop="invoice_time" label="开票日期"></el-table-column>
          <el-table-column label="是否审核">
            <template #default="scope">
              <span v-if="scope.row.check_status > 0">已审核</span>
              <span v-else>未审核</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="380px">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" v-if="ERP.isPermission(26005002002002)" :disabled="scope.row.check_status > 0" @click="updateInvoice(scope.row)">修改</el-button>
              <el-button size="mini" v-if="ERP.isPermission(26005002002001)" :disabled="scope.row.check_status > 0" @click="checkInvoice(scope.row)">审核</el-button>
              <el-button size="mini" v-if="ERP.isPermission(26005002002001)" :disabled="scope.row.check_status < 1" @click="checkInvoice(scope.row)">反审核</el-button>
              <el-button size="mini" type="danger" v-if="ERP.isPermission(26005002002003)" :disabled="scope.row.check_status > 0" @click="delInvoice(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
    </el-dialog>

  </div>
</template>

<script>

import CommonHelp from "./common/CommonHelp";
import UploadFilesSysc from "./components/UploadFilesSysc";
import AreaTree from "./components/AreaTree";
import Api from "./common/Api";
import {Message} from "element-ui";

export default {
  name:"ContractFinanceInvoice",
  components: {AreaTree, UploadFilesSysc},
  data () {
    return {
      host_url:"",
      upload_url : '',
      keyword: '',
      loading: false,
      contract_area_id:'',
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      pageChannelData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      rules: {
        invoice_type: [
          { required: true, message: '请选择发票类型', trigger: 'change' },
        ],
        ticket_no: [
          { required: true, message: '请填输入发票', trigger: 'blur' },
        ],
        invoice_time: [
          { required: true, message: '请选择发票时间', trigger: 'change' },
        ],
        is_void: [
          { required: true, message: '请选择款项类型', trigger: 'change' },
        ],
      },
      form:{
        name:"",
        invoice_type:"",
        ticket_no:"",
        finance_id:"",
        amount:0,
        invoice_time:"",
        files:"",
        status:true,
        remarks:"",
      },
      uploadUrl:"",
      month_money_list:[],
      project_list:[],
      month_value:"",
      start_month : '',
      end_month : '',
      multipleSelection:[],
      check_status : '',
      f_status:"2,3",
      business_list:[],
      entry_type_name:"",
      // 开票列表
      invoiceRow : {},
      invoiceList : [],
      invoiceListVisible : false,
      upload_file_list : [],
    }
  },
  created() {
    this.host_url=CommonHelp.getBaseURL();
    this.upload_url = Api.getUploadUrl('/contract/FinanceInvoice/batchInvoice')
    this.start_month = CommonHelp.date("YYYY-MM");
    this.end_month = CommonHelp.date("YYYY-MM");
    // this.month_value=CommonHelp.date("YYYY-MM");
    // this.getList()
    this.getBusinessList()
  },
  activated() {
    this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        this.multipleSelection = []
      }
    },
    "form.province_city_ids":function (n) {
      n&&n[0]&&(this.form.province_id=n[0])
      n&&n[1]&&(this.form.city_id=n[1])
      console.log(n)
    },
    "form.contract_area_ids":function (n) {
      console.log(n)
    },
    invoice_account(n){
      console.log(n);
    },
    finance_ids(n){
      console.log(n)
    }

  },
  computed:{
    Api() {
      return Api
    },
    invoice_account(){
      return this.multipleSelection.reduce(function(total, currentValue, currentIndex){
        total+=(currentValue.invoice_amount*1);
        return total;
      }, 0)
    },
    finance_ids(){
      return this.multipleSelection.map(ret=>{return ret.id;})
    },
    search_params(){
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      // this.month_value&&(where.month=this.month_value);
      this.entry_type_name&&(where.entry_type_name=this.entry_type_name);
      where.start_month = this.start_month;
      where.end_month = this.end_month;
      where.check_status = this.check_status;
      return where;
    },
  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        name:"",
        invoice_type:"",
        ticket_no:"",
        finance_id:"",
        amount:0,
        invoice_time:"",
        files:"",
        status:true,
        remarks:"",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      CommonHelp.get("FinanceInvoice/getList",{
        where:JSON.stringify(this.search_params),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          res.data.list.map(ret=>{
            ret.is_end=ret.is_end === 1;
            ret.is_invoice=ret.is_invoice === 1;
            ret.is_paid=ret.is_paid === 1;
            ret.invoice_amount=ret.invoice_amount>0?ret.invoice_amount:ret.amount;
            return ret;
          })
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    invoice(item) {
      this.invoiceRow = item;
      this.invoiceListVisible = true;
      this.getInvoiceList(item.id);
    },
    invoiceForm(){
      let item=CommonHelp.reObject(this.invoiceRow)
      this.multipleSelection=[item];
      this.invoices(item);
    },
    invoices(){
      this.form = this.getFormData({})
      this.form.amount=this.invoice_account;
      this.form.finance_id=this.finance_ids[0];
      this.dialogVisible = true
    },
    getInvoiceList(id){
      let that = this;
      Api.invoiceList({id : id , 'invoice_status' : 1} , 0 , 0 ,(res) => {
        that.invoiceList = res.list;
      })
    },
    checkInvoice(row){
      var that=this;
      that.$confirm('是否确定操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        CommonHelp.post("FinanceInvoice/check_status_change",{ids:row.id},res=>{
          if(res.code) {
            that.getInvoiceList(row.finance_id);
          }else {
            that.$message({
              type: 'warning',
              message: res.msg||"请求异常"
            });
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消审核'
        });
      });
    },

    submitForm(formName) {
      var that=this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.formLoading = true
          let data = Object.assign({}, this.form)
          CommonHelp.post("FinanceInvoice/save",data,res => {
            that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
            if(res.code) {
              that.dialogVisible = false
              that.multipleSelection=[];
              that.getList()
              this.getInvoiceList(data.finance_id)
            }
            that.formLoading = false
          })
        } else {
          return false;
        }
      });
    },

    setFrom(data){
      var that=this;
      CommonHelp.post("FinanceInvoice/save",data,res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.multipleSelection=[];
          that.getList()
        }
      })
    },
    onAreaChange({data,pathData,ids}){
      this.form.province_city=data.mergename;
      this.form.province_city_ids=ids.join(',')
    },
    onContractAreaChange({data,pathData,ids}){
      let adrr=""
      pathData.map((ret,index)=>{
        adrr+=ret.name+(pathData[index+1]?' -> ':'')
      })
      this.form.contract_area=adrr;
      this.form.contract_area_ids=ids.join(',')
    },
    nodeClick1(n){
      this.contract_area_id=n.id;
      this.pageData={
        list:[],
        total:0,
        pageSize:20,
        page:1
      }
      this.getList()
    },
    exportExcel(){
      var that=this;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      CommonHelp.get("Finance/exportExcel",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          window.open(that.host_url + res.data)
        }
      })
    },
    importExcel(){
      var that=this;
      CommonHelp.uploadFile(ret=>{
        // console.log(ret);
        CommonHelp.post("Finance/importExcel",{ file_name:ret },res=>{
          if(res.code) {
            that.getList();
            if(res.data&&res.data.length){
              that.error_show_status=true;
              that.error_list=res.data;
            }
          }else {
            this.$message(res.msg);
          }
        })
      });
    },
    getBusinessList(){
      var that=this;
      CommonHelp.get("Business/getList",{
        page: 1,
        page_size: 100
      },res=>{
        if(res.code) {
          that.business_list=res.data.list
        }
      })
    },
    selectable(row,index){
      let is_invoice=row.is_invoice;
      let status=row.status === 2;
      let is_end=!row.is_end;
      console.log(is_invoice&&status&&is_end , is_invoice , status , is_end)
      return is_invoice&&status&&is_end;
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    date(time){
      return CommonHelp.date("YYYY-MM-DD",time)
    },
    // 修改开票
    updateInvoice(row){
      this.form = this.getFormData(row);
      let item = CommonHelp.reObject(this.invoiceRow);
      this.multipleSelection=[item];
      this.form.ticket_no=row.ticket_no;
      this.form.name=row.name;
      this.form.invoice_type=row.invoice_type;
      this.form.amount=row.amount;
      this.form.finance_id=row.finance_id;
      this.form.id = row.id;
      this.form.status = 1;
      this.dialogVisible = true
    },
    // 删除开票
    delInvoice(id) {
      let that = this;
      this.$confirm('确认删除吗？', '提示' , {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Api.invoiceDel(id , res => {
          that.invoiceListVisible = false;
          that.dialogVisible = false;
          that.getList();
        })
      })
    },
    uploadComplete(res){
      if(res.code){
        Message.success(res.msg)
        this.upload_file_list = [];
        this.getList();
      }else{
        Message.error(res.msg);
      }
    },
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 230px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/ContractFinanceInvoice.vue